try {
	    if ($("#ProductSelect-product-template-28-pack").length > 0) {
          console.log("START NEW");
	        var prods,
	            filteredProds,
	            handle,
	            strawberry,
	            newID = 41669672960222;
	        $(".js-change-number").on("click", function () {
               console.log("CHANGED");
	            setTimeout(function () {
	                var skuToChange = $("#ProductSelect-product-template-28-pack").val();
                  var product_id = $("input[name='product-id']").val();
	                if ($(".js-product-selection-input").val() != "") {
	                    var variant = $(".js-product-selection-input").val();
	                    variant = variant.split(",").sort().join(", ");
	                     console.log(variant);
                        
                        if (product_id == 7330574663902) {
                          newID = 41669672960222;  
                        }else {
                          newID = 41669672960222;  
                        }

                        console.log(variant);
	                    $("#product-selection").val(variant);
	                    $("#ProductSelect-product-template-28-pack").find("option").remove();
	                    $("#ProductSelect-product-template-28-pack").append($("<option>", { value: newID, text: "", selected: !0 }));
	                } 
	            }, 500);
	        });
	    }
	} catch (err) {
	    console.log(err);
	}
	